import { allInputs, enableJSCheckbox } from './element-selectors';
import {
  highlight,
  loadContent,
  runSandbox,
  saveContent,
} from './sandbox-utils';
import jsx from '../jsx';

export const setupSandboxInputHandlers = () => {
  allInputs.forEach((input) => {
    const id = input.getAttribute('id') || 'unknown';

    input.addEventListener('input', () => {
      highlight(input);
      saveContent(input);
    });
    input.addEventListener('keyup', () => highlight(input));
    input.addEventListener('scroll', (event) => {
      const codeElement = document.getElementById(
        `${id}-pre`,
      ) as HTMLPreElement;

      codeElement.scrollTop = input.scrollTop;
      codeElement.scrollLeft = input.scrollLeft;
    });
    input.addEventListener('keydown', (event) => {
      if ((event.ctrlKey || event.metaKey) && event.code === 'KeyS') {
        event.preventDefault();
        runSandbox();
      }

      if (event.code === 'Tab') {
        event.preventDefault();

        const isShiftHeld = event.shiftKey;
        const inputValue = input.value;

        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;

        const inputStart = inputValue.substring(0, selectionStart);
        const inputEnd = inputValue.substring(selectionEnd);

        if (isShiftHeld) {
          if (inputStart.match(/\t$/)) {
            input.value = inputStart.replace(/\t([^\t]*)$/, '') + inputEnd;
            input.selectionStart = input.selectionEnd = selectionStart - 1;
          }
        } else {
          input.value = inputStart + '\t' + inputEnd;

          input.selectionStart = input.selectionEnd = selectionStart + 1;
        }
      }
    });
    input.addEventListener('blur', () => runSandbox());

    loadContent(input);
    highlight(input);

    const header = document.getElementById(`${id}-header`);

    if (header) {
      const existing = localStorage.getItem(`${id}-collapsed`);

      if (existing) {
        const state = parseInt(existing); // 0 or 1

        if (state) {
          header.parentElement?.setAttribute(
            'class',
            'editorItemWrapper collapsed',
          );
        }
      }

      header.append(
        <button
          onclick={() => {
            if (
              header.parentElement?.getAttribute('class')?.includes('collapsed')
            ) {
              header.parentElement?.setAttribute('class', 'editorItemWrapper ');
              localStorage.setItem(`${id}-collapsed`, '0');
            } else {
              header.parentElement?.setAttribute(
                'class',
                'editorItemWrapper collapsed',
              );
              localStorage.setItem(`${id}-collapsed`, '1');
            }
          }}
        ></button>,
      );
    }
  });
  enableJSCheckbox.addEventListener('click', () => {
    runSandbox();
  });
};
